import { AccessExport, Search, SubscriptionExport, BillingExport, Dashboard } from 'projects/access-gui/views/core'
import { About } from 'views/core'

module.exports = [
  {
    path: '/export/subscriptions',
    exact: true,
    component: SubscriptionExport
  }, {
    path: '/export/access',
    exact: true,
    component: AccessExport
  }, {
    path: '/export/billing/:id',
    exact: true,
    component: BillingExport
  }, {
    path: '/search',
    exact: true,
    component: Search
  }, {
    path: '/about',
    exact: true,
    component: About
  }, {
    path: '/dashboard',
    exact: true,
    component: Dashboard
  }
]



// WEBPACK FOOTER //
// ./src/projects/access-gui/routes/core.js